import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface DepotsCellProps {
  rowData: ManagedFleet;
}

export default function DepotsCell({ rowData: { totals } }: DepotsCellProps) {
  return <TextCell text={String(totals?.enabledAssetGroupingsCount)} />;
}
